import React from "react";

import { ReploIconBlack } from "@svg/replo-icon-black";

import { useParams } from "react-router-dom";

import OnboardingSetupShop from "./OnboardingSetupShop";
import OnboardingShopInfo from "./OnboardingShopInfo";
import OnboardingUserInfo from "./OnboardingUserInfo";

const stepComponents = {
  "user-info": OnboardingUserInfo,
  "shop-info": OnboardingShopInfo,
  "setup-shop": OnboardingSetupShop,
} as const;

const OnboardingLayout = ({
  children,
  showLogo = true,
}: {
  children: React.ReactNode;
  showLogo?: boolean;
}) => {
  return (
    <div className="bg-neutral-soft flex h-screen w-full items-stretch justify-center md:p-6">
      <div className="md:border-border shadow-button-selectable relative h-full w-full overflow-hidden border bg-white md:rounded-[24px]">
        {showLogo && (
          <div className="absolute left-4 top-4 hidden md:left-8 md:top-8 md:block">
            <ReploIconBlack className="h-6 w-6 md:h-8 md:w-8" />
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

const Onboarding: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { onboardingStep } = useParams<{ onboardingStep?: string }>();
  const StepComponent = onboardingStep
    ? stepComponents[onboardingStep as keyof typeof stepComponents]
    : null;

  if (!StepComponent) {
    return null;
  }

  return (
    <OnboardingLayout>
      <StepComponent />
      {children}
    </OnboardingLayout>
  );
};

export default Onboarding;
